module.exports = __webpack_public_path__ + "img/role03.dd05bea6.png";